import React, { ReactElement } from "react";
import {
  Box,
  Divider,
  Grid,
  Text,
  useMantineTheme,
} from "@advarra-engineering/advarra-design-system-react";
import {
  adsFontSizeSm,
  adsFontSizeXs,
  adsColorTurquoise100,
} from "@advarra-engineering/advarra-design-system-design-tokens";
import { IconBulb, IconRulerMeasure, IconHistory } from "@tabler/icons-react";
import { t } from "i18next";

interface PasswordRuleProps {
  icon: ReactElement;
  title: string;
  description: string;
}

export const PasswordRecommendations = () => {
  return (
    <>
      <Divider style={{ background: adsColorTurquoise100 }} />
      <Text size={"md"} style={{ padding: ".3rem 0" }}>
        {t("password-recommendations.title")}
      </Text>
      <Divider style={{ background: adsColorTurquoise100 }} />
      <Grid m="10px 0">
        <Grid.Col md={4}>
          <PasswordRule
            icon={<IconBulb size={24} stroke={1} />}
            title={t("password-recommendations.unique-title")}
            description={t("password-recommendations.unique-description")}
          />
        </Grid.Col>
        <Grid.Col md={4}>
          <PasswordRule
            icon={<IconRulerMeasure size={24} stroke={1} />}
            title={t("password-recommendations.long-title")}
            description={t("password-recommendations.long-description")}
          />
        </Grid.Col>
        <Grid.Col md={4}>
          <PasswordRule
            icon={<IconHistory size={24} stroke={1} />}
            title={t("password-recommendations.memorable-title")}
            description={t("password-recommendations.memorable-description")}
          />
        </Grid.Col>
      </Grid>
      <Divider style={{ background: adsColorTurquoise100 }} />
    </>
  );
};

const PasswordRule = (props: PasswordRuleProps) => {
  const theme = useMantineTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "stretch",
        padding: ".1rem .5rem",
        gap: theme.spacing.xs,
      }}
    >
      <Box
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
        aria-hidden="true"
      >
        <IconWithRoundedBorder icon={props.icon} />
      </Box>
      <Box sx={{ alignItems: "center" }}>
        <Text size="sm" sx={{ fontSize: adsFontSizeSm, margin: 0 }}>
          {props.title}
        </Text>
        <Text
          sx={{
            fontSize: adsFontSizeXs,
          }}
        >
          {props.description}
        </Text>
      </Box>
    </Box>
  );
};

const IconWithRoundedBorder = ({ icon }: { icon: ReactElement }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: adsColorTurquoise100,
        borderRadius: "50%",
        padding: "10px",
      }}
    >
      {icon}
    </Box>
  );
};
